import { ApiError } from '@lib/api-error';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { Subscription } from 'types/collections';

import { DailyAvailability } from '@components/DaySelectionPanel';

import { SubscriptionService } from '@services/SubscriptionService';

export const useSubscription = () => {
  const queryClient = useQueryClient();

  const { data, isPending, isError, error } = useQuery<Subscription[], ApiError>({
    queryKey: ['teacher-subscriptions'],
    queryFn: () => new SubscriptionService().getSubscriptions(),
  });

  const createSubscriptionMutation = useMutation({
    mutationFn: ({
      listing_id,
      selectedDays,
    }: {
      listing_id: string;
      selectedDays: DailyAvailability;
    }) => new SubscriptionService().createSubscriptions(listing_id, selectedDays),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['teacher-subscriptions'] });
    },
  });

  const updateSubscriptionMutation = useMutation({
    mutationFn: ({
      subscriptionId,
      selectedDays,
    }: {
      subscriptionId: string;
      selectedDays: DailyAvailability;
    }) => new SubscriptionService().updateSubscriptions(subscriptionId, selectedDays),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['teacher-subscriptions'] });
    },
  });

  const deleteSubscriptionMutation = useMutation({
    mutationFn: (subscriptionId: string) =>
      new SubscriptionService().deleteSubscription(subscriptionId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['teacher-subscriptions'] });
    },
  });

  return {
    subscriptions: data,
    isPending,
    isError,
    error,
    createSubscription: createSubscriptionMutation.mutate,
    deleteSubscription: deleteSubscriptionMutation.mutate,
    updateSubscription: updateSubscriptionMutation.mutate,
  };
};
